<template>
    <transition
        :css="false"
        :appear="true"
        @enter="intro"
        @appear="intro"
        @leave="outro"
    >
        <div class="RotateDevice" v-show="show">
            <div class="RotateDevice-inner">
                <line-icon
                    v-show="iconVisible"
                    class="RotateDevice-icon"
                    key="icon-up"
                    :width="icon.width"
                    :height="icon.height"
                    :d="icon.d"
                    :intro-delay="0.75"
                ></line-icon>
                <p ref="copy" class="RotateDevice-copy">
                    <small v-if="isMobile">
                        Mantén tu dispositivo en horizontal para poder vivir
                        esta experiencia.
                    </small>
                    <small v-else>
                        Extiende tu navegador para poder vivir esta experiencia.
                    </small>
                </p>
                <line-icon
                    v-show="iconVisible"
                    class="RotateDevice-icon RotateDevice-icon--polar"
                    key="icon-down"
                    :width="icon.width"
                    :height="icon.height"
                    :d="icon.d"
                    :intro-delay="1"
                ></line-icon>
            </div>
        </div>
    </transition>
</template>

<script>
    import isMobile from 'ismobilejs'
    import app from '@/app'
    import LineIcon from '@/app/components/LineIcon'

    export default {
        name: 'RotateDevice',
        components: {
            LineIcon,
        },
        data() {
            return {
                isMobile: isMobile.any,
                width: window.innerWidth,
                height: window.innerHeight,
                count: 0,
                iconVisible: false,
            }
        },
        mounted() {
            this.updateSize()
            app.resize.add(this.updateSize)
        },
        beforeDestroy() {
            app.resize.remove(this.updateSize)
        },
        methods: {
            intro(el, done) {
                const {$refs} = this
                // Force LineIcon intro-transition
                this.iconVisible = true
                TweenMax.fromTo($refs.copy, 0.2,
                    {y: 15, alpha: 0},
                    {y: 0, alpha: 1, delay: 0.5, onComplete: done})
            },
            outro(el, done) {
                this.iconVisible = false
                done()
            },
            updateSize() {
                // Timeout needed because IOS Chrome
                let to = setTimeout(() => {
                    this.width = window.innerWidth
                    this.height = window.innerHeight
                    clearTimeout(to)
                    to = null
                }, 100)
            },
        },
        computed: {
            ratio() {
                const {width, height} = this
                return width / height
            },
            show() {
                const {ratio} = this
                return ratio < 1.3
            },
            icon() {
                const {isMobile, $store} = this
                if (isMobile) {
                    return $store.getters.data.lineIcons.rotate
                }
                return $store.getters.data.lineIcons.expand
            },
        },
    }
</script>

<style src="styles/components/base/RotateDevice.styl" lang="stylus"></style>



// WEBPACK FOOTER //
// src/app/components/base/RotateDevice.vue